import Flickity from 'flickity';

export default class ProductFeaturedIntegrations {
  constructor() {
    const $els = document.querySelectorAll('.js-product-featured-ingtegrations');

    $els.forEach(($el) => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.$carousel = $el.querySelector('.js-product-featured-ingtegrations-carousel');
    this.$prevBtn = $el.querySelector('.js-product-featured-ingtegrations-carousel-prev-btn');
    this.$nextBtn = $el.querySelector('.js-product-featured-ingtegrations-carousel-next-btn');
    this.$tabs = this.$el.querySelectorAll('.js-product-featured-ingtegrations-tab');
    this.$backgrounds = this.$el.querySelectorAll('.js-product-featured-integrations-background-text');
    this.activeClass = 'is-active';

    this.flickity = new Flickity(this.$carousel, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      imagesLoaded: true,
    });

    this.flickity.on('select', this.onSelect.bind(this));

    this.$prevBtn.addEventListener('click', this.handlePrevClick.bind(this));
    this.$nextBtn.addEventListener('click', this.handleNextClick.bind(this));

    this.$tabs.forEach(($tab, index) => {
      $tab.addEventListener('click', this.goToSlide.bind(this, $tab, index));
    });
  }

  handlePrevClick() {
    this.flickity.previous();
  }

  handleNextClick() {
    this.flickity.next();
  }

  goToSlide($tab, index = 0) {
    if (!this.flickity || !$tab) return;

    this.$tabs.forEach($tab => $tab.classList.remove(this.activeClass));
    $tab.classList.add(this.activeClass);

    this.flickity.select(index);
  }

  onSelect(index) {
    this.$tabs.forEach($tab => $tab.classList.remove(this.activeClass));
    this.$tabs[index]?.classList.add(this.activeClass);

    this.$backgrounds.forEach($background => $background.classList.remove(this.activeClass));
    this.$backgrounds[index]?.classList.add(this.activeClass);
  }
}
